import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import checkImg from "../../public/icon/check.png";
import { BlueLink } from "../BlueLink";

const Tips = () => {
  const { locale } = useRouter();

  return locale === "cn" ? (
    <div className="w-[400px] text-[14px] font-normal leading-[24px] opacity-60 text-center">
      感谢兑换，可以在&nbsp;
      <BlueLink href="/points" style={{ color: "inherit" }}>
        我的积分-兑换明细
      </BlueLink>
      &nbsp;中查看兑换明细（实物商品物流等）定制商品会有工作人员在7个工作日内联系您
    </div>
  ) : (
    <div className="w-[400px] text-[14px] font-normal leading-[24px] opacity-60 text-center">
      Thanks you. Check your order details in&nbsp;
      <BlueLink href="/points" style={{ color: "inherit" }}>
        My CUP Points - Order History
      </BlueLink>
      &nbsp;(Track your package, etc.); If you redeemed a personalized gift, we
      will contact you within 7 business days
    </div>
  );
};

export const Confirmed = ({ extra = null }) => {
  const { t } = useTranslation("mall");

  return (
    <div className="flex flex-col items-center justify-center rounded-[40px] overflow-hidden bg-white pt-[62px] pb-[56px]">
      <Image src={checkImg} width={96} height={96} alt="" quality={100} />

      <div className="mt-[40px] mb-[16px] text-[40px] leading-[48px] font-bold font-DIN_Alternate">
        {t("confirmed")}
      </div>

      <Tips />

      {extra}
    </div>
  );
};
